module.exports = __webpack_public_path__ + "img/icn_brand15_black.ecbc7f2a.svg";